export enum SubscribedStatus {
  active = "active",
  canceled = "canceled",
  pending = "pending",
  expired = "expired",
}
